module.exports = __webpack_public_path__ + "img/rating-pos.5e8b2931.svg";